export default __webpack_public_path__ + "static/media/cert-finance-hkgcsmeaa-sc.a6616870.jpg";